import React from "react";
import { LicitacoesProvider } from "./context/licitacoes-context";
import { Licitacoes } from "./licitacoes";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const LicitacoesFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Licitações"}>
            <LicitacoesProvider>
                <Licitacoes />
            </LicitacoesProvider>
        </BaseInternalFormFactory>
    );
};

export default LicitacoesFactory;
